import React, {Component} from 'react';

import {Player, PlayerEvent, TimelineReferencePoint} from 'bitmovin-player/modules/bitmovinplayer-core';
import EngineBitmovinModule from 'bitmovin-player/modules/bitmovinplayer-engine-bitmovin';
import MseRendererModule from 'bitmovin-player/modules/bitmovinplayer-mserenderer';
import HlsModule from 'bitmovin-player/modules/bitmovinplayer-hls';
import AbrModule from 'bitmovin-player/modules/bitmovinplayer-abr';
import ContainerTSModule from 'bitmovin-player/modules/bitmovinplayer-container-ts';
import SubtitlesModule from 'bitmovin-player/modules/bitmovinplayer-subtitles';
import PolyfillModule from 'bitmovin-player/modules/bitmovinplayer-polyfill';
import StyleModule from 'bitmovin-player/modules/bitmovinplayer-style';
import DashModule from 'bitmovin-player/modules/bitmovinplayer-dash';
import XmlModule from 'bitmovin-player/modules/bitmovinplayer-xml';

import {UIFactory} from 'bitmovin-player/bitmovinplayer-ui';
import 'bitmovin-player/bitmovinplayer-ui.css';


Player.addModule(EngineBitmovinModule);
Player.addModule(MseRendererModule);
Player.addModule(HlsModule);
Player.addModule(AbrModule);
Player.addModule(ContainerTSModule);
Player.addModule(SubtitlesModule);
Player.addModule(PolyfillModule);
Player.addModule(StyleModule);
Player.addModule(XmlModule);
Player.addModule(DashModule);


class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            player: [],
        };


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let {player} = this.state;
        //if (prevProps.src !== this.props.src ) {
        player.load({
            hls: this.props.src,
            poster: this.props.poster
        });
        //}
    }


    setupPlayer = () => {
        document.addEventListener('touchstart', null, true);
        let container = document.getElementById('player');
        const config = {
            key: "a9438b8a-97ae-4502-955b-fe615878e8c7",

        };
        let player = new Player(container, config);
        console.log("ffffyyyy", player.getCurrentTime());

        UIFactory.buildDefaultUI(player);
        this.setState({player});
    };


    render() {
        console.log("currentTime", this.state.player);
        console.log("PlayerEvent", PlayerEvent);

        if (this.state.player !== null)
            // console.log("ffff", this.state.player.getCurrentTime());
        return (
            <div id="player" ref={this.setupPlayer}/>
        );
    }
}

export default VideoPlayer;